var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconZoomIn = function SvgIconZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.898 7.57a7.618 7.618 0 0 1-1.316 4.294L18 16.354 16.38 18l-4.374-4.444A7.34 7.34 0 0 1 7.45 15.14C3.334 15.14 0 11.75 0 7.57S3.334 0 7.449 0c4.114 0 7.449 3.39 7.449 7.57Zm-13.294 0c0 3.275 2.622 5.94 5.845 5.94s5.844-2.665 5.844-5.94c0-3.275-2.621-5.94-5.844-5.94-3.223 0-5.845 2.665-5.845 5.94Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.251 6.871V3.96H6.647v2.912H3.782v1.63h2.865v2.912H8.25V8.502h2.865v-1.63H8.251Z",
    fill: "currentColor"
  })));
};
export default SvgIconZoomIn;